import type { NotificationRow } from "../types/database";
import { supabase } from "./supabase";

export async function listMyNotifications(limit = 50): Promise<NotificationRow[]> {
  const { data, error } = await supabase
    .from("notifications")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(limit);
  if (error || !data) return [];
  return data as NotificationRow[];
}

export async function getUnreadCount(): Promise<number> {
  const { data, error } = await supabase.rpc("count_unread_notifications");
  if (error) {
    console.warn("[notifications] unread count failed:", error.message);
    return 0;
  }
  return typeof data === "number" ? data : 0;
}

export async function markNotificationRead(id: string): Promise<{ error: Error | null }> {
  const { error } = await supabase
    .from("notifications")
    .update({ read_at: new Date().toISOString() })
    .eq("id", id);
  if (error) {
    console.warn("[notifications] mark read failed:", error.message);
    return { error: new Error(error.message) };
  }
  return { error: null };
}

export async function markAllNotificationsRead(): Promise<{ error: Error | null }> {
  const { error } = await supabase.rpc("mark_all_notifications_read");
  if (error) {
    console.warn("[notifications] mark all read failed:", error.message);
    return { error: new Error(error.message) };
  }
  return { error: null };
}
